import { Canceler } from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { FixedTab, RouteTabs } from '../../../components/RouteTabs';
import useSnackbar from '../../../hooks/useSnackbar';
import api from '../../../services/api/base';
import { IHomeDisplayStyle } from '../../../services/types';
import { RouteNames } from '../../config';
import CreateDisplayStyle from './CreateDisplayStyle';
import DisplayStyleList from './DisplayStyleList';
import { getHomeDisplayStyles } from '../../../services/api/DisplayStyle';

interface IProps {}

interface IParamProps {
  displayStyleId?: string;
}

const DisplayStyle = (props: IProps & RouteComponentProps): JSX.Element => {
  const path = RouteNames.DisplayStyle;

  const history = useHistory();

  const [displayStyleList, setDisplayStyleList] = useState<IHomeDisplayStyle[]>();
  const [hasMore, setHasMore] = useState<boolean>(false);

  const snackbar = useSnackbar();

  const canceler = useRef<Canceler>(() => undefined);

  const handleError = useCallback(
    e => {
      snackbar.error(`An error has occurred. ${e.message}`);
    },
    [snackbar],
  );

  const fetchData = useCallback(async () => {
    canceler.current();

    try {
      const [fetchPromise, cancel] = getHomeDisplayStyles();
      canceler.current = cancel;

      const result = await fetchPromise;

      setDisplayStyleList(result.data.items);
      setHasMore(result.data.hasMore);
    } catch (e) {
      if (api.isCancel(e)) return;
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    fetchData();

    return () => canceler.current();
  }, [fetchData]);

  const handleCreate = useCallback(() => {
    fetchData();

    snackbar.success('Saved successfully.');

    history.push(RouteNames.DisplayStyle);
  }, [history, snackbar, fetchData]);

  return (
    <RouteTabs path={path}>
      <FixedTab label="Display Styles">
        <DisplayStyleList {...props} displayStyleList={displayStyleList} />
      </FixedTab>
      <FixedTab label="Create a Display Style" uri="create">
        <CreateDisplayStyle {...props} onCreate={handleCreate} onError={handleError} />
      </FixedTab>
    </RouteTabs>
  );
};

export default DisplayStyle;
